<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Международный медицинский центр</h3>
            <p class="depth">
                Международный медицинский центр Медицинского центра Женского университета Ихва оказывает полный спектр услуг в области здравоохранения для зарубежных пациентов в дружелюбной обстановке. Мы выстраиваем долгосрочные отношения с иностранными госорганами, например Вооруженными силами США в Корее, SOS International и Министерством здравоохранения ОАЭ; сотрудничество с медицинскими учреждениями со всего мира также является одним из наших ценных достижений, которое помогает нам лучше обслуживать различных зарубежных пациентов. Мы оказываем неотложную медицинскую помощь, амбулаторную помощь, обслуживание в клинике для амбулаторных больных, стационарное лечение, предлагаем оздоровительные программы и посвящаем себя здоровью и инновациям для предоставления безусловно лучшей помощи нашим пациентам и их семьям со всего мира.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Услуги консьержа и координатора</h3>
            <p class="depth">
                Медицинский центр Женского университета Ихва оказывает медицинскую помощь зарубежным пациентам из более чем 60 стран мира. Центр укомплектован высококвалифицированными и опытными специалистами, владеющими английским, китайским, русским и арабским языками, и предлагает специфические в культурном плане программы, включая консьерж-услуги и VIP-палаты для наших особенных гостей в целях максимально комфортного обслуживания пациентов.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Однодневное обслуживание</h3>
            <p class="depth">
                Мы понимаем, что для зарубежных пациентов время является крайне важным фактором. По этой причине мы предлагаем своим пациентам однодневное обслуживание, которое включает в себя услуги по консультации и обследованию, предоставляемые в тот же день. Мы также предлагаем услуги координатора, который будет оказывать помощь зарубежным пациентам на всех этапах, начиная с регистрации и бронирования жилья и заканчивая выпиской, и даже транспорта из/в аэропорт.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Часы работы (Международный медицинский центр)</h3>
            <div class="info information-call__box">
                <div class="information-call__img"><img alt="" src="/resource/icon/phon.png">
                    <h4 class="pc-none">Будние дни : 09:00 ~ 17:00</h4>
                </div>

                <div class="information-call__text">
                    <h4 class="mo-none">Будние дни : 09:00 ~ 17:00</h4>

                    <p>
                        суббота : нерабочий день <br>
                        Воскресенье и праздничные дни : посетите отделение экстренной медицинской помощи на первом этаже.
                    </p>
                </div>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Местоположение (Международный медицинский центр)</h3>
            <h4 class="bullet02">(Международный медицинский центр) располагается на первом этаже.</h4>
            <div class="layout mt20">
                <div class="layout__inner">
                    <div class="layout__info">
                        <div class="layout__store">
                            <h4 class="layout__store-tit">1F</h4>
                            <ul class="layout__store-list">
                                <!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if-->
                                <li class="layout__store-item active">
                                    <button type="button">Международный медицинский центр</button>
                                </li><!--v-if--><!--v-if-->
                                
                            </ul>
                        </div>
                        <div class="layout__map">
                            <!-- <h3 class="tit"><span class="num">{{current.floor}}</span><span class="circle"></span></h3> -->
                            <div class="pin active" style="bottom: 27%;right:calc(9.7% - 26px)"><img
                                    src="/resource/icon/pin.svg" alt="이미지" class="active"></div><img
                                src="/displayFile.do?name=20241128.1527.25.184.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>